export const fetchGetJson = async (url, config) => {
  const res = await fetch(url, config)

  if (!res.ok) {
    throw new Error(res.statusText)
  }

  return res.json()
}



// WEBPACK FOOTER //
// ./src/services/fetch-get-json.js